import * as React from 'react'

import Grid from '@mui/material/Unstable_Grid2'
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'

import Text from 'components/atomic/atoms/text'
import { GridSize } from '@mui/material'

interface FilterItem {
    slug: string
    title: string
    count: number
}

interface ListItem {
    slug: string
}

interface ItemListProps<T extends ListItem> {
    activeFilters: FilterItem[]
    items: T[]
    count: number
    onRemoveFilter: (slug: string) => void
    renderItem: (item: T) => JSX.Element
    itemColumns?: {
        xs?: boolean | GridSize | undefined
        sm?: boolean | GridSize | undefined
        md?: boolean | GridSize | undefined
        lg?: boolean | GridSize | undefined
        xl?: boolean | GridSize | undefined
    }
}

export default function ItemList<T extends ListItem>(props: ItemListProps<T>) {
    const handleRemoveFilter = (slug: string) => {
        props.onRemoveFilter(slug)
    }

    const renderItem = React.useCallback((item: T) => props.renderItem(item), [props])

    return (
        <Stack py={2} sx={{ flexGrow: 1 }}>
            {/* Active filters */}
            <Stack direction={'row'} spacing={1} sx={{ height: '48px' }} alignItems={'center'} paddingX={1}>
                <Text variant="h6" marginRight={1}>
                    {props.count} risultati
                </Text>
                {props.activeFilters.map((filter) => (
                    <Chip
                        size="small"
                        key={filter.slug}
                        label={filter.title}
                        onDelete={() => handleRemoveFilter(filter.slug)}
                    />
                ))}
            </Stack>

            {/* Items */}
            <Box p={1}>
                <Grid container spacing={{ xs: 2, md: 1 }}>
                    {props.items.map((item) => (
                        <Grid {...props.itemColumns} key={item.slug}>
                            {renderItem(item)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Stack>
    )
}
